const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_da_part3 = {
  overlyGenericPrompts: "Alt For Generiske Prompts",
  genericPromptsDesc: "prompts er for generiske. Gør dem mere specifikke for din virksomhed.",
  overlyLongContent: "Alt For Langt Indhold",
  longContentDesc: "prompts er meget lange. Overvej at opdele dem i mindre, fokuserede stykker.",
  reviewOldContent: "Gennemse Gammelt Indhold",
  oldContentDesc:
    "elementer er ældre end 6 måneder og har muligvis brug for opdatering for at afspejle nuværende bedste praksis.",
  expiredContentCleanup: "Oprydning af Udløbet Indhold",
  expiredContentDesc: "udløbne elementer der sikkert kan fjernes.",
  found: "Fundet",
  aiAnalysis: "AI Analyse",
  runAnalysis: "Kør Analyse",
  analyzing: "Analyserer...",
  potentialDuplicates: "Potentielle Dubletter",
  recommendations: "Anbefalinger",
  totalItems: "Samlede Elementer",
  duplicates: "Dubletter",
  [duplicateTranslationKey("backToUpload")]: "Tilbage til Upload",
  markAsHandled: "Marker som håndteret",
  markAsNotHandled: "Marker som ikke håndteret",
  showHandled: "Vis håndterede",
  [duplicateTranslationKey("confidence")]: "Tillid",
  [duplicateTranslationKey("affectedItems")]: "Berørte elementer",
  [duplicateTranslationKey("entry")]: "Post",
  [duplicateTranslationKey("originalEntries")]: "Oprindelige poster",
  [duplicateTranslationKey("suggestedMergedEntry")]: "Foreslået sammenlagt post",
  [duplicateTranslationKey("applyMerge")]: "Anvend sammenlægning",
  [duplicateTranslationKey("cancel")]: "Annuller",
  [duplicateTranslationKey("mergeSuggestion")]: "Sammenlægningsforslag",
  [duplicateTranslationKey("loading")]: "Indlæser",
  [duplicateTranslationKey("suggestMerge")]: "Foreslå sammenlægning",
  generateImprovementSuggestion: "Generer forbedringsforslag",
  [duplicateTranslationKey("generating")]: "Genererer",
  aiSuggestion: "AI Forslag",
  [duplicateTranslationKey("current")]: "Nuværende",
  [duplicateTranslationKey("improved")]: "Forbedret",
  [duplicateTranslationKey("suggestion")]: "Forslag",
  applySuggestion: "Anvend forslag",
  [duplicateTranslationKey("applying")]: "Anvender",
  [duplicateTranslationKey("showMore")]: "Vis mere",
  [duplicateTranslationKey("showLess")]: "Vis mindre",
  [duplicateTranslationKey("identicalTitles")]: "Identiske titler i samme videnbase",
  [duplicateTranslationKey("similarTitlesContent")]: "Meget lignende titler og relateret indhold",
  [duplicateTranslationKey("similarContent")]: "Meget lignende indhold i samme videnbase",
  // Bug reporting translations
  // Bug reporting translations
  bugStatus: "Fejlstatus",
  report: "Rapportér",
  reported: "rapporteret",
  internal: "intern",
  resolved: "løst",
  [duplicateTranslationKey("suggestion")]: "idé",
  test_feedback: "test-feedback",
  markResolved: "Markér som løst",
  removeStatus: "Fjern fejlstatus",
  reportBug: "Rapportér fejl",
  reportInternalBug: "Rapportér intern fejl",
  reportSuggestion: "Rapportér idé",
  reportCriticalBug: "Rapportér kritisk fejl",
  reportAdminBug: "Rapportér admin fejl",
  critical_bug: "kritisk fejl",
  admin_bug: "admin fejl",
  showBugReport: "Rapportér",
  hideBugReport: "Skjul fejlrapport",
  reportTypeOptions: "Vælg rapporttype eller tilføj kommentar",
  assign: "Tildel",
  assignedTo: "Tildelt til",
  assignedToMe: "Tildelt til mig",
  assignedToYou: "Tildelt til dig",
  unassign: "Fjern tildeling",
  unassigned: "Ikke tildelt",
  unknownUser: "Ukendt bruger",
  addCommentOrViewComments: "Tilføj kommentar / Se kommentarer",
  commentsLabel: "Kommentarer",
  noComments: "Ingen kommentarer endnu",
  usernamePlaceholder: "Dit navn",
  addCommentPlaceholder: "Tilføj en kommentar...",
  addComment: "Tilføj kommentar",
  adding: "Tilføjer...",
  editComment: "Rediger kommentar",
  deleteComment: "Slet kommentar",
  confirmDeleteComment: "Er du sikker på, at du vil slette denne kommentar?",
  save: "Gem",
  commentPlaceholder: "Kommentar",
  unreadComments: "Ulæste kommentarer",
  userIDLabel: "Bruger ID",
  title: "Titel",
  text: "Tekst",
  selectIndexes: "Vælg indekser",
  enterTitle: "Indtast titel",
  enterText: "Indtast tekst",
  selectExpirationDate: "Vælg udløbsdato",
  errorUploadingData: "Fejl ved upload af data",
  "Title is Required": "Titel er påkrævet",
  "Index is Required": "Indeks er påkrævet",
  uploadDataTitle: "Upload Data",
  // PDF Chunking translations
  // PDF Chunking translations
  smartChunking: "Smart Opdeling",
  smartChunkingTooltip:
    "Opdeler automatisk PDF i meningsfulde dele baseret på titler, afsnit og indholdsstruktur. Anbefales for bedre søgenøjagtighed.",
  pdfChunkingResults: "PDF Opdelings Resultater",
  totalChunks: "Antal Dele",
  avgSize: "Gns. Størrelse",
  range: "Interval",
  chars: "tegn",
  chunkUploadNote: "Hver del vil blive uploadet som en separat, søgbar post",
  // PDF Upload translations
  // PDF Upload translations
  uploadPdfLabel: "Upload PDF (valgfri)",
  uploadPdfButton: "Upload PDF",
  extractingText: "Udtrækker tekst...",
  uploadPdfDescription: "Upload en PDF-fil for automatisk at udtrække og udfylde teksten nedenfor",
  pdfLoaded: "Indlæst",
  verifyFileType: "Filtypen er ikke gyldig. Vælg en PDF-fil.",
  // Error message translations
  // Error message translations
  uploadFailedContentTooLong:
    "Upload fejlede: Indholdet er for langt til behandling. Prøv at opdele i mindre sektioner eller brug PDF-upload med automatisk opdeling.",
  uploadFailedAIProcessing: "Upload fejlede: AI-behandlingsfejl. Tjek dit indhold og prøv igen.",
  uploadFailedInvalidExpiration: "Upload fejlede: Ugyldig udløbsdato format.",
  uploadFailedInvalidSchedule: "Upload fejlede: Ugyldig tidsplan format.",
};
